import AxiosService from '../AxiosService';
import { queryString, apiUrl } from '../config/globals';

export const startUpList = (data, params) => AxiosService.post(`${apiUrl('user', 'private')}/search?${queryString(params)}`, data);

export const addStartUp = (data) => AxiosService.post(`${apiUrl('user', 'private')}/create`, data);

export const updateStartUp = (data) => AxiosService.put(`${apiUrl('user', 'private')}/update`, data);

export const activateStartUp = (data) => AxiosService.put(`${apiUrl('user', 'private')}/activation?${queryString(data)}`);

export const viewStartUp = (data) => AxiosService.get(`${apiUrl('user', 'private')}/view?${queryString(data)}`);

export const deleteStartUp = (data) => AxiosService.delete(`${apiUrl('user', 'private')}/delete?${queryString(data)}`);

export const uploadStartUpXls = (data) => AxiosService.post(`${apiUrl('user', 'private')}/upload-excel`, data);
